export default __webpack_public_path__ + "static/media/truck.9c71bc60.svg";